// ─── Sender Addresses (Royal Gems Inc. offices) ───────────────────────────────
export const MOCK_SENDERS = [
    {
        addressId: 'sender_nyc',
        name: 'David Rosenberg',
        company: 'Royal Gems Inc.',
        address1: '580 Fifth Avenue',
        address2: 'Suite 1200',
        city: 'New York',
        state: 'NY',
        zip: '10036',
        country: 'US',
        phone: '212-555-0147',
    },
    {
        addressId: 'sender_la',
        name: 'Rachel Goldstein',
        company: 'Royal Gems Inc.',
        address1: '550 S Hill Street',
        address2: 'Suite 800',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90013',
        country: 'US',
        phone: '213-555-0293',
    },
    {
        addressId: 'sender_miami',
        name: 'Michael Stern',
        company: 'Royal Gems Inc.',
        address1: '36 NE 1st Street',
        address2: 'Suite 420',
        city: 'Miami',
        state: 'FL',
        zip: '33132',
        country: 'US',
        phone: '305-555-0184',
    },
    {
        addressId: 'sender_chicago',
        name: 'Sarah Levine',
        company: 'Royal Gems Inc.',
        address1: '5 S Wabash Avenue',
        address2: 'Suite 1500',
        city: 'Chicago',
        state: 'IL',
        zip: '60603',
        country: 'US',
        phone: '312-555-0376',
    },
    {
        addressId: 'sender_dallas',
        name: 'Jonathan Weiss',
        company: 'Royal Gems Inc.',
        address1: '15301 Dallas Pkwy',
        address2: 'Suite 200',
        city: 'Dallas',
        state: 'TX',
        zip: '75248',
        country: 'US',
        phone: '972-555-0219',
    },
];
// ─── Recipient Addresses ───────────────────────────────────────────────────────
export const MOCK_RECIPIENTS = [
    {
        recipientId: 'recip_001',
        name: 'Alexandra Chen',
        company: 'Brilliance Jewelers',
        labelName: 'Brilliance Jewelers - A. Chen',
        address1: '718 Sansome Street',
        address2: '',
        city: 'San Francisco',
        state: 'CA',
        zip: '94111',
        country: 'US',
        phone: '415-555-0812',
        email: 'achen@brilliancejewelers.com',
        isResidential: false,
        isVerified: true,
    },
    {
        recipientId: 'recip_002',
        name: 'Marcus Rivera',
        company: 'Rivera Fine Diamonds',
        labelName: 'Rivera Fine Diamonds',
        address1: '2 W 46th Street',
        address2: 'Floor 3',
        city: 'New York',
        state: 'NY',
        zip: '10036',
        country: 'US',
        phone: '212-555-0934',
        email: 'marcus@riverafinediamonds.com',
        isResidential: false,
        isVerified: true,
    },
    {
        recipientId: 'recip_003',
        name: 'Emily Thornton',
        company: '',
        labelName: 'Emily Thornton',
        address1: '4521 Maple Drive',
        address2: 'Apt 7B',
        city: 'Scottsdale',
        state: 'AZ',
        zip: '85251',
        country: 'US',
        phone: '480-555-0267',
        email: 'emily.thornton@gmail.com',
        isResidential: true,
        isVerified: true,
    },
    {
        recipientId: 'recip_004',
        name: 'James Hartwell',
        company: 'Hartwell & Sons Jewelers',
        labelName: 'Hartwell & Sons Jewelers',
        address1: '112 E Grace Street',
        address2: '',
        city: 'Richmond',
        state: 'VA',
        zip: '23219',
        country: 'US',
        phone: '804-555-0451',
        email: 'james@hartwelljewelers.com',
        isResidential: false,
        isVerified: true,
    },
    {
        recipientId: 'recip_005',
        name: 'Priya Sharma',
        company: 'Luxe Diamond Exchange',
        labelName: 'Luxe Diamond Exchange - P. Sharma',
        address1: '1901 Avenue of the Stars',
        address2: 'Suite 1050',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90067',
        country: 'US',
        phone: '310-555-0693',
        email: 'priya@luxediamondexchange.com',
        isResidential: false,
        isVerified: true,
    },
    {
        recipientId: 'recip_006',
        name: 'Robert Tanaka',
        company: 'Pacific Gem Traders',
        labelName: 'Pacific Gem Traders',
        address1: '601 Union Street',
        address2: 'Suite 4200',
        city: 'Seattle',
        state: 'WA',
        zip: '98101',
        country: 'US',
        phone: '206-555-0118',
        email: 'rtanaka@pacificgem.com',
        isResidential: false,
        isVerified: true,
    },
    {
        recipientId: 'recip_007',
        name: 'Catherine Dubois',
        company: '',
        labelName: 'Catherine Dubois',
        address1: '891 Peachtree Street NE',
        address2: 'Unit 2204',
        city: 'Atlanta',
        state: 'GA',
        zip: '30309',
        country: 'US',
        phone: '404-555-0587',
        email: 'catherine.dubois@outlook.com',
        isResidential: true,
        isVerified: false,
    },
    {
        recipientId: 'recip_008',
        name: 'Daniel Abramov',
        company: 'Crown Jewels Wholesale',
        labelName: 'Crown Jewels Wholesale - Receiving',
        address1: '1 Jewelry Center Drive',
        address2: 'Bldg C',
        city: 'Providence',
        state: 'RI',
        zip: '02903',
        country: 'US',
        phone: '401-555-0742',
        email: 'receiving@crownjewelswholesale.com',
        isResidential: false,
        isVerified: true,
    },
];
// ─── Basic Reference Data ──────────────────────────────────────────────────────
export const MOCK_BASIC_DATA = {
    packagingTypes: [
        { value: 'FEDEX_ENVELOPE', label: 'FedEx Envelope' },
        { value: 'FEDEX_PAK', label: 'FedEx Pak' },
        { value: 'FEDEX_SMALL_BOX', label: 'FedEx Small Box' },
        { value: 'FEDEX_MEDIUM_BOX', label: 'FedEx Medium Box' },
        { value: 'YOUR_PACKAGING', label: 'Your Packaging' },
    ],
    serviceTypes: [
        { value: 'FEDEX_PRIORITY_OVERNIGHT', label: 'FedEx Priority Overnight' },
        { value: 'FEDEX_STANDARD_OVERNIGHT', label: 'FedEx Standard Overnight' },
        { value: 'FEDEX_2_DAY', label: 'FedEx 2Day' },
        { value: 'FEDEX_EXPRESS_SAVER', label: 'FedEx Express Saver' },
        { value: 'FEDEX_GROUND', label: 'FedEx Ground' },
    ],
};
// ─── Cost Breakdown Generator ──────────────────────────────────────────────────
const SERVICE_BASE_RATES = {
    FEDEX_PRIORITY_OVERNIGHT: 45,
    FEDEX_STANDARD_OVERNIGHT: 32,
    FEDEX_2_DAY: 22,
    FEDEX_EXPRESS_SAVER: 18,
    FEDEX_GROUND: 12,
};
export function generateMockCostBreakdown(serviceType, weight, declaredValue) {
    const baseRate = SERVICE_BASE_RATES[serviceType] ?? 25;
    const weightSurcharge = weight > 1 ? (weight - 1) * 2.5 : 0;
    const insurance = declaredValue * 0.005;
    const fuelSurcharge = baseRate * 0.175;
    const finalAmount = baseRate + weightSurcharge + insurance + fuelSurcharge;
    return {
        finalAmount: finalAmount.toFixed(2),
        breakdown: [
            {
                title: 'Base Rate',
                displayValue: `$${baseRate.toFixed(2)}`,
                messageType: 'base',
            },
            ...(weightSurcharge > 0
                ? [
                    {
                        title: 'Weight Surcharge',
                        displayValue: `$${weightSurcharge.toFixed(2)}`,
                        messageType: 'surcharge',
                    },
                ]
                : []),
            {
                title: 'Declared Value Insurance',
                displayValue: `$${insurance.toFixed(2)}`,
                messageType: 'insurance',
            },
            {
                title: 'Fuel Surcharge (17.5%)',
                displayValue: `$${fuelSurcharge.toFixed(2)}`,
                messageType: 'surcharge',
            },
            {
                title: 'Total',
                displayValue: `$${finalAmount.toFixed(2)}`,
                messageType: 'total',
            },
        ],
        zoneId: 'zone-4',
        calculatedAt: new Date().toISOString(),
    };
}
// ─── Helper to build a shipment record ─────────────────────────────────────────
function makeShipment(index, status, trackingNumber, sender, recipient, serviceType, packagingType, weight, declaredValue, createdAt, updatedAt, delivery, source = 'wizard') {
    const id = `ship_mock_${String(index).padStart(3, '0')}`;
    const cost = generateMockCostBreakdown(serviceType, weight, declaredValue);
    cost.calculatedAt = createdAt;
    return {
        id,
        userId: 'mock-user',
        type: 'shipment',
        status,
        source,
        trackingNumber,
        shipmentId: trackingNumber ? `SHIP${trackingNumber.slice(-6)}` : null,
        confirmationNumber: trackingNumber ? `CONF${trackingNumber.slice(-8)}` : null,
        sender,
        recipient,
        package: {
            packagingType,
            serviceType,
            weight,
            dimensions: { length: 10, width: 8, height: 4 },
            declaredValue,
            signatureType: declaredValue > 5000 ? 'DIRECT' : 'INDIRECT',
            saturdayDelivery: false,
            holdForPickup: false,
        },
        cost,
        delivery,
        documents: {
            labelLink: trackingNumber ? `/api/labels/${id}.pdf` : null,
            returnLabelLink: null,
            commercialInvoiceLink: declaredValue > 2500 ? `/api/invoices/${id}.pdf` : null,
            receiptLink: trackingNumber ? `/api/receipts/${id}.pdf` : null,
        },
        createdBy: 'mock-user',
        createdAt,
        updatedAt,
    };
}
// ─── Delivery helpers ──────────────────────────────────────────────────────────
const noDelivery = {
    deliveredTo: null,
    deliveredDate: null,
    deliveredSignature: null,
    fedexStatus: null,
};
function deliveredInfo(date, to, signature) {
    return {
        deliveredTo: to,
        deliveredDate: date,
        deliveredSignature: signature,
        fedexStatus: 'Delivered',
    };
}
// ─── 15 Mock Shipments ─────────────────────────────────────────────────────────
export const MOCK_SHIPMENTS = [
    // --- 3 DRAFT ---
    makeShipment(1, 'draft', null, MOCK_SENDERS[0], MOCK_RECIPIENTS[0], 'FEDEX_PRIORITY_OVERNIGHT', 'FEDEX_SMALL_BOX', 0.8, 12500, '2026-03-15T10:30:00Z', '2026-03-15T10:30:00Z', noDelivery),
    makeShipment(2, 'draft', null, MOCK_SENDERS[1], MOCK_RECIPIENTS[4], 'FEDEX_STANDARD_OVERNIGHT', 'FEDEX_ENVELOPE', 0.3, 3200, '2026-03-17T14:20:00Z', '2026-03-17T14:20:00Z', noDelivery),
    makeShipment(3, 'draft', null, MOCK_SENDERS[3], MOCK_RECIPIENTS[6], 'FEDEX_2_DAY', 'FEDEX_PAK', 0.5, 850, '2026-03-18T09:15:00Z', '2026-03-18T09:15:00Z', noDelivery),
    // --- 3 IN_TRANSIT ---
    makeShipment(4, 'in_transit', '748965210048', MOCK_SENDERS[0], MOCK_RECIPIENTS[1], 'FEDEX_PRIORITY_OVERNIGHT', 'FEDEX_SMALL_BOX', 1.2, 18750, '2026-03-14T08:00:00Z', '2026-03-14T16:45:00Z', { ...noDelivery, fedexStatus: 'In Transit - On FedEx vehicle for delivery' }),
    makeShipment(5, 'in_transit', '748965210055', MOCK_SENDERS[2], MOCK_RECIPIENTS[5], 'FEDEX_STANDARD_OVERNIGHT', 'FEDEX_MEDIUM_BOX', 2.5, 24800, '2026-03-13T11:30:00Z', '2026-03-14T07:20:00Z', { ...noDelivery, fedexStatus: 'In Transit - Arrived at FedEx location' }),
    makeShipment(6, 'in_transit', '270012349876', MOCK_SENDERS[4], MOCK_RECIPIENTS[7], 'FEDEX_2_DAY', 'YOUR_PACKAGING', 3.1, 8400, '2026-03-12T15:00:00Z', '2026-03-13T22:10:00Z', { ...noDelivery, fedexStatus: 'In Transit - Departed FedEx hub' }),
    // --- 5 DELIVERED ---
    makeShipment(7, 'delivered', '748965210062', MOCK_SENDERS[0], MOCK_RECIPIENTS[2], 'FEDEX_PRIORITY_OVERNIGHT', 'FEDEX_SMALL_BOX', 0.6, 7200, '2026-02-28T09:00:00Z', '2026-03-01T14:23:00Z', deliveredInfo('2026-03-01T14:23:00Z', 'Front Door', 'E.THORNTON')),
    makeShipment(8, 'delivered', '748965210079', MOCK_SENDERS[1], MOCK_RECIPIENTS[3], 'FEDEX_STANDARD_OVERNIGHT', 'FEDEX_PAK', 0.4, 4600, '2026-02-20T10:15:00Z', '2026-02-21T11:50:00Z', deliveredInfo('2026-02-21T11:50:00Z', 'Receptionist', 'J.HARTWELL')),
    makeShipment(9, 'delivered', '270012349883', MOCK_SENDERS[3], MOCK_RECIPIENTS[0], 'FEDEX_2_DAY', 'FEDEX_MEDIUM_BOX', 1.8, 15300, '2026-02-10T13:00:00Z', '2026-02-12T16:40:00Z', deliveredInfo('2026-02-12T16:40:00Z', 'Shipping Dock', 'A.CHEN')),
    makeShipment(10, 'delivered', '748965210086', MOCK_SENDERS[2], MOCK_RECIPIENTS[4], 'FEDEX_EXPRESS_SAVER', 'FEDEX_ENVELOPE', 0.2, 2100, '2026-01-25T08:45:00Z', '2026-01-28T10:15:00Z', deliveredInfo('2026-01-28T10:15:00Z', 'Mailroom', 'P.SHARMA')),
    makeShipment(11, 'delivered', '270012349890', MOCK_SENDERS[4], MOCK_RECIPIENTS[1], 'FEDEX_GROUND', 'YOUR_PACKAGING', 4.5, 950, '2026-01-15T14:30:00Z', '2026-01-22T09:05:00Z', deliveredInfo('2026-01-22T09:05:00Z', 'Security Desk', 'M.RIVERA'), 'import'),
    // --- 2 IMPORTED ---
    makeShipment(12, 'imported', '748965210093', MOCK_SENDERS[0], MOCK_RECIPIENTS[7], 'FEDEX_PRIORITY_OVERNIGHT', 'FEDEX_SMALL_BOX', 1.0, 21000, '2026-03-10T07:30:00Z', '2026-03-10T07:30:00Z', { ...noDelivery, fedexStatus: 'Shipment information sent to FedEx' }, 'import'),
    makeShipment(13, 'imported', '270012349907', MOCK_SENDERS[2], MOCK_RECIPIENTS[3], 'FEDEX_STANDARD_OVERNIGHT', 'FEDEX_PAK', 0.7, 5800, '2026-03-08T16:00:00Z', '2026-03-08T16:00:00Z', { ...noDelivery, fedexStatus: 'Picked up' }, 'import'),
    // --- 1 EXCEPTION ---
    makeShipment(14, 'exception', '748965210109', MOCK_SENDERS[1], MOCK_RECIPIENTS[6], 'FEDEX_STANDARD_OVERNIGHT', 'FEDEX_SMALL_BOX', 0.9, 6700, '2026-03-05T12:00:00Z', '2026-03-07T08:30:00Z', {
        deliveredTo: null,
        deliveredDate: null,
        deliveredSignature: null,
        fedexStatus: 'Delivery exception - Business closed',
    }),
    // --- 1 VOIDED ---
    makeShipment(15, 'voided', '748965210116', MOCK_SENDERS[4], MOCK_RECIPIENTS[2], 'FEDEX_2_DAY', 'FEDEX_ENVELOPE', 0.3, 500, '2026-03-01T09:00:00Z', '2026-03-01T11:45:00Z', noDelivery),
];
